module.exports = __webpack_public_path__ + "assets/c76813774d24f7196ff513a69a16a3da.svg";